import React from "react";
import DemoHeader from "./DemoHeader";
import StockTicker from "./Ticker";

const DemoLayout = ({ children }) => {
  return (
    <>
    <StockTicker/>
      <DemoHeader />
      {children}
    </>
  );
};

export default DemoLayout;
